// Maps raw tachograph event/fault type strings (as decoded from the card/VU) to i18n keys.
// Mirrors the mapping used in the import file-info modal so labels stay consistent.
const EVENT_TYPE_KEYS: Record<string, string> = {
  'General events - Card conflict': 'importModule.fault-card-conflict',
  'General events - Card insertion while driving': 'importModule.fault-card-insertion-driving',
  'General events - Driving without an appropriate card': 'importModule.fault-driving-no-card',
  'General events - Insertion of a non-valid card': 'importModule.fault-invalid-card',
  'Insertion of a non-valid card': 'importModule.fault-invalid-card',
  'General events - Last card session not correctly closed': 'importModule.fault-session-not-closed',
  'General events - Motion data error': 'importModule.fault-motion-data-error',
  'General events - Power supply interruption': 'importModule.fault-power-supply',
  'General events - Time overlap': 'importModule.fault-time-overlap',
  'General events - Over speeding': 'importModule.fault-over-speeding',
  'Sensor related security breach attempt events - Internal data transfer error': 'importModule.fault-sensor-transfer-error',
  'Vehicle unit related security breach attempt events - Card data input integrity error': 'importModule.fault-card-integrity',
  'Vehicle unit related security breach attempt events - Hardware sabotage': 'importModule.fault-hardware-sabotage',
  'Vehicle unit related security breach attempt events - Internal data transfer error': 'importModule.fault-internal-transfer',
  'Vehicle unit related security breach attempt events - Motion sensor authentication failure': 'importModule.fault-sensor-auth',
  'Vehicle unit related security breach attempt events - Stored user data integrity error': 'importModule.fault-data-integrity',
  'Vehicle unit related security breach attempt events - Tachograph card authentication failure': 'importModule.fault-card-auth',
  'Vehicle unit related security breach attempt events - Unauthorised case opening': 'importModule.fault-case-opening',
  'Vehicle unit related security breach attempt events - Unauthorised change of motion sensor': 'importModule.fault-sensor-change',
  'Card faults - No further details': 'importModule.fault-card-no-details',
  'Recording equipment faults - Downloading fault': 'importModule.fault-download',
  'Recording equipment faults - No further details': 'importModule.fault-no-details',
  'Recording equipment faults - Printer fault': 'importModule.fault-printer',
  'Recording equipment faults - Sensor fault': 'importModule.fault-sensor',
  'Recording equipment faults - VU internal fault': 'importModule.fault-vu-internal',
  'Manufacturer specific': 'importModule.fault-manufacturer',
}

export function translateTachographEventType(
  eventType: string | null | undefined,
  t: (key: string) => string,
): string {
  if (!eventType) return '—'
  const key = EVENT_TYPE_KEYS[eventType]
  return key ? t(key) : eventType
}

// Standard EventFaultType codes (Annex 1C, Appendix 1). The decoder keeps only the
// descriptive string, so we map it back to the regulation's hex code for display.
const EVENT_TYPE_CODES: Record<string, string> = {
  'General events - Insertion of a non-valid card': '0x01',
  'Insertion of a non-valid card': '0x01',
  'General events - Card conflict': '0x02',
  'General events - Time overlap': '0x03',
  'General events - Driving without an appropriate card': '0x04',
  'General events - Card insertion while driving': '0x05',
  'General events - Last card session not correctly closed': '0x06',
  'General events - Over speeding': '0x07',
  'General events - Power supply interruption': '0x08',
  'General events - Motion data error': '0x09',
  'General events - Vehicle Motion Conflict': '0x0A',
  'Vehicle unit related security breach attempt events - No further details': '0x10',
  'Vehicle unit related security breach attempt events - Motion sensor authentication failure': '0x11',
  'Vehicle unit related security breach attempt events - Tachograph card authentication failure': '0x12',
  'Vehicle unit related security breach attempt events - Unauthorised change of motion sensor': '0x13',
  'Vehicle unit related security breach attempt events - Card data input integrity error': '0x14',
  'Vehicle unit related security breach attempt events - Stored user data integrity error': '0x15',
  'Vehicle unit related security breach attempt events - Internal data transfer error': '0x16',
  'Vehicle unit related security breach attempt events - Unauthorised case opening': '0x17',
  'Vehicle unit related security breach attempt events - Hardware sabotage': '0x18',
  'Sensor related security breach attempt events - No further details': '0x20',
  'Sensor related security breach attempt events - Authentication failure': '0x21',
  'Sensor related security breach attempt events - Stored data integrity error': '0x22',
  'Sensor related security breach attempt events - Internal data transfer error': '0x23',
  'Sensor related security breach attempt events - Unauthorised case opening': '0x24',
  'Sensor related security breach attempt events - Hardware sabotage': '0x25',
  'Recording equipment faults - No further details': '0x30',
  'Recording equipment faults - VU internal fault': '0x31',
  'Recording equipment faults - Printer fault': '0x32',
  'Recording equipment faults - Display fault': '0x33',
  'Recording equipment faults - Downloading fault': '0x34',
  'Recording equipment faults - Sensor fault': '0x35',
  'Card faults - No further details': '0x40',
}

export function getTachographEventCode(
  eventType: string | null | undefined,
): string {
  if (!eventType) return '—'
  return EVENT_TYPE_CODES[eventType] ?? '—'
}
